/**
 * Created by zml on 4/22/2016.
 */

'use strict';
(function () {


  var bathPath = 'angular-adminlte';

  angular
    .module('angular-adminlte', ['ui.router', 'ngSanitize'])

    .constant('ADM_PATHS', {
      BASE: bathPath,
      COMMON: bathPath + '/components/common',
      CONTENT: bathPath + '/components/content',
      CTRLBAR: bathPath + '/components/ctrlbar',
      FOOTER: bathPath + '/components/footer',
      HEADER: bathPath + '/components/header',
      SIDEBAR: bathPath + '/components/sidebar'
    });

})();

'use strict';

/**
 * Created by cxh on 11/26/2015.
 */
angular.module('dsaComponents', ['angular-adminlte', 'ngCookies', 'ngSanitize', 'restangular', 'ui.router', 'pascalprecht.translate', 'ab-base64', 'LocalStorageModule', 'angularSpinner', 'angularMoment', 'sharedConfig'])
  .constant('dsaComponentsConfig', {
    productName: '',
    serverBaseUrl: '',
    loginUrl: 'user/login',
    logoutUrl: 'user/logout',
    webSocketUrl: 'notify',
    unProtectedStates: [],
    jqxDefaultSetting: {
      comboxHeight: 32
    }
  })
  .run(function (dsaComponentsConfig, AuthenticationService, $rootScope, $location, $cookies, $http, $state) {
    // keep user logged in after page refresh
    AuthenticationService.initHeaderFromCookie();

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      $rootScope.toState = toState;

      var loginStateName = dsaComponentsConfig.moduleName ? dsaComponentsConfig.moduleName + '.' + 'login' : 'login';

      if ($rootScope.toState.name !== loginStateName) {
        // redirect to login page if not logged in
        if (!AuthenticationService.isAuthorized()) {
          event.preventDefault();//prevent the state change.
          $rootScope.returnToState = $rootScope.toState.name;
          $rootScope.returnToStateParams = toParams;
          $state.go(loginStateName);
        }
      }
    });

    $rootScope.$state = $state;

    $rootScope.$on('$stateChangeError',
      function (event, toState, toParams, fromState, fromParams, error) {
        console.log(error);
      });

  });

/**
 * Created by zml on 4/21/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admFramework', AdmFrameworkComponent);

  AdmFrameworkComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmFrameworkComponent(ADM_PATHS) {
    var directive = {
      bindToController: true,
      controller: AdmFrameworkController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.BASE + '/adm-framework.component.html',
      restrict: 'E',
      scope: {},
      replace: true,
      transclude: true
      //transclude: {
      //  'title': '?paneTitle',
      //  'body': 'paneBody',
      //  'footer': '?paneFooter'
      //}
    };
    return directive;
  }

  AdmFrameworkController.$inject = ['AdmStatusService'];

  /* @ngInject */
  function AdmFrameworkController(AdmStatusService) {
    var vm = this;

    vm.sideBarStatus = AdmStatusService.getSideBarStatus();
    vm.isSidebarCollapsed = isSidebarCollapsed;
    vm.isSidebarVisible = isSidebarVisible;

    function isSidebarCollapsed() {
      return AdmStatusService.getSideBarStatus().isCollapsed;
    }

    function isSidebarVisible() {
      return AdmStatusService.getSideBarStatus().isVisible;
    }
  }

})();


/**
 * Created by zml on 4/21/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .service('AdmStatusService', AdmStatusService);

  AdmStatusService.$inject = ['PubSubService'];

  /* @ngInject */
  function AdmStatusService(PubSubService) {

    var sideBarStatus = {
      isCollapsed: false,
      isVisible: true
    };

    var ctrlBarStatus = {
      isOpened: false
    };

    this.toggleSidebar = toggleSidebar;
    this.getSideBarStatus = getSideBarStatus;
    this.setSidebarVisible = setSidebarVisible;

    this.toggleCtrlBar = toggleCtrlBar;
    this.getCtrlBarStatus = getCtrlBarStatus;

    ////////////////

    function getSideBarStatus() {
      return sideBarStatus;
    }

    function toggleSidebar() {
      sideBarStatus.isCollapsed = !sideBarStatus.isCollapsed;
      PubSubService.publish('_TOGGLE_SIDEBAR_');
    }

    function getCtrlBarStatus() {
      return ctrlBarStatus;
    }

    function toggleCtrlBar() {
      ctrlBarStatus.isOpened = !ctrlBarStatus.isOpened;
    }

    function setSidebarVisible(visible) {
      sideBarStatus.isVisible = visible;
    }


  }

})();


/**
 * Created by rak on 11/10/2014.
 */
'use strict';

angular.module('dsaComponents')
  .service('AuthenticationService', function (dsaComponentsConfig, $http, $cookies, $rootScope, base64, Restangular, errorHandlingService, languageService, accountConfig) {
    var authUrl = dsaComponentsConfig.serverBaseUrl + '/' + dsaComponentsConfig.loginUrl;
    //var self = this;

    var setCredentials = function (loginID, password, detail) {
      var authdata = base64.encode(loginID.username + ':' + password);

      $rootScope.globals = {
        currentUser: {
          loginID: loginID,
          authdata: authdata,
          detail: detail
        }
      };

      var accountID = window.location.hostname.split('.')[0];
        if(accountID in accountConfig.imprintUrls) {
        $rootScope.globals.currentUser.loginID.Account = accountID;
      }

      $http.defaults.headers.common['Authorization'] = 'Basic ' + authdata; // jshint ignore:line

      addOtherLoginIDFieldsToHeader(loginID);

      $cookies.putObject(getAuthKeyInCookie(), $rootScope.globals);
    };

    var clearCredentials = function () {
      delete $rootScope.globals;
      $cookies.remove(getAuthKeyInCookie());
    };



    var addOtherLoginIDFieldsToHeader = function (loginID) {
      //put other loginID fields to header.
      _.forIn(loginID, function (value, key) {
        if (key !== 'username') {
          var headerName = 'X-' + getAuthKeyInCookie() + '-' + key;
          $http.defaults.headers.common[headerName] = value;
        }
      });
    };
    this.clearUserCredentials = function () {
      clearCredentials();
    };
    this.Login = function (loginID, password) {
      var accountID = window.location.hostname.split('.')[0];
      if(accountID in accountConfig.imprintUrls) {
        loginID.Account = accountID;
      }

      clearCredentials();

      addOtherLoginIDFieldsToHeader(loginID);

      var authdata = base64.encode(loginID.username + ':' + password);
      return $http.get(authUrl, {
        headers: { 'Authorization': 'Basic ' + authdata },
        timeout: 10000
      }).then(function (response) {
        setCredentials(loginID, password, response);
        $rootScope.$emit('_AUTH_CHANGED_');
        if (response.data.message) {
          $rootScope.globals.currentUser.loginMessage = response.data.message;
        }
        return response;
      });
    };

    this.logout = function () {
      return Restangular.one(dsaComponentsConfig.logoutUrl).get().finally(function () {
        clearCredentials();
        $rootScope.$emit('_AUTH_CHANGED_');
        errorHandlingService.closeJqxNotificationInfo();
      });
    };

    this.setCredentialsExtern = function (loginID, password, detail) {
      var authdata = base64.encode(loginID.username + ':' + password);

      $rootScope.globals = {
        currentUser: {
          loginID: loginID,
          authdata: authdata,
          detail: detail,
          loginMessage: ''
        }
      };

      $http.defaults.headers.common['Authorization'] = 'Basic ' + authdata; // jshint ignore:line

      addOtherLoginIDFieldsToHeader(loginID);

      $cookies.putObject(getAuthKeyInCookie(), $rootScope.globals);
    };

    this.changePassword = function (oldPassword, newPassword) {

      var baseUserREST;
      if (dsaComponentsConfig.userBaseUrl) {
        baseUserREST = Restangular.all(dsaComponentsConfig.userBaseUrl);
      } else {
        // For backward compatibility.
        baseUserREST = Restangular.all('user');
      }

      var username = this.GetLoginUserName();
      var loginID = this.GetLoginID();

      return baseUserREST.customOperation('put', username + '/password', '', '', {
        'password': oldPassword,
        'newPassword': newPassword
      }).then(function () {
        clearCredentials();
        setCredentials(loginID, newPassword);
      });
    };

    this.forgotPassword = function (loginID, email) {
      clearCredentials();

      addOtherLoginIDFieldsToHeader(loginID);

      if (languageService.getLanguageSettings() && languageService.getLanguageSettings().language) {
        var language = languageService.getLanguageSettings().language;
        var headerName = 'X-' + getAuthKeyInCookie() + '-' + 'Locale';
        $http.defaults.headers.common[headerName] = language;
      }

      var baseUserREST;
      if (dsaComponentsConfig.userBaseUrl) {
        baseUserREST = Restangular.all(dsaComponentsConfig.userBaseUrl);
      } else {
        // For backward compatibility.
        baseUserREST = Restangular.all('user');
      }

      return baseUserREST.customOperation('put', 'forgotpassword', '', '', {
        'username': loginID.username,
        'email': email
      }).then(function () {
        clearCredentials();
      });
    };

    this.IsLogin = function () {
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        return true;
      }

      return false;
    };

    this.GetLoginUserName = function () {
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        return $rootScope.globals.currentUser.loginID.username;
      }

      return null;
    };

    this.GetUserDetail = function () {
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        return $rootScope.globals.currentUser.detail;
      }
      return null;
    };

    this.GetLoginID = function () {
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        return $rootScope.globals.currentUser.loginID;
      }

      return null;
    };

    this.getCredentials = function () {
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        var credentials = {
          loginID: $rootScope.globals.currentUser.loginID,
          password: base64.decode($rootScope.globals.currentUser.authdata).split(':')[1]
        };
        return credentials;
      }
      return null;
    };

    this.initHeaderFromCookie = function () {
      $rootScope.globals = $cookies.getObject(getAuthKeyInCookie()) || {};
      if (typeof $rootScope.globals === 'string') { // can be string if window reload is used
        $rootScope.globals = JSON.parse($rootScope.globals);
      }
      if ($rootScope.globals && $rootScope.globals.currentUser) {
        $http.defaults.headers.common.Authorization = 'Basic ' + $rootScope.globals.currentUser.authdata;

        addOtherLoginIDFieldsToHeader($rootScope.globals.currentUser.loginID);
      }
    };

    this.isAuthorized = function () {
      // redirect to login page if not logged in
      if (!$cookies.getObject(getAuthKeyInCookie())) {
        var isUnProtectedState = false;

        for (var i = 0; i < dsaComponentsConfig.unProtectedStates.length; i++) {
          if ($rootScope.toState.name === dsaComponentsConfig.unProtectedStates[i]) {
            isUnProtectedState = true;
          }
        }

        return isUnProtectedState;
      }
      if (!this.IsLogin()) {
        this.initHeaderFromCookie();
      }

      return true;
    };

    function getAuthKeyInCookie() {
      if (dsaComponentsConfig.moduleName) {
        return dsaComponentsConfig.productName + '.' + dsaComponentsConfig.moduleName;
      } else {
        return dsaComponentsConfig.productName;
      }
    }

  }).factory('httpAuthenticationInterceptor', function ($q, $window, $injector, dsaComponentsConfig) {
    var httpAuthenticationInterceptor = {
      request: function (config) {
        var regex = /forgotpassword/i;
        if (regex.test(config.url))
          //Detach the header
          delete config.headers.Authorization;
        return config;
      },
      responseError: function (response) {

        if (response.config.url.indexOf(dsaComponentsConfig.loginUrl) === -1 && response.config.url.indexOf(dsaComponentsConfig.logoutUrl) === -1 && response.status === 401) {
          var translation = $injector.get('$translate');
          var text = translation.instant('login.error.unauthorized');

          $window.alert(text);
          var stateService = $injector.get('$state');
          stateService.go('logout');
        }
        // Return the promise rejection.
        return $q.reject(response);
      }
    };
    return httpAuthenticationInterceptor;
  }).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('httpAuthenticationInterceptor');
  }]);


/**
 * Created by rak on 12/30/2014.
 */
'use strict';
angular.module('dsaComponents')
  .service('crudService', function (Restangular) {

    this.getList = function (model, param) {
      return Restangular.all(model).getList(param);
    };

    this.getListOfSubResource = function (model, id, subModel) {
      return Restangular.one(model, id).getList(subModel);
    };

    this.getListOfSubResourceByCompositeId = function (model, id, id2, subModel) {
      return Restangular.all(model).customGETLIST(id + '/' + id2 + '/' + subModel);
      //return Restangular.one(model, id).one('', id2).getList(subModel);
    };
    this.get = function (model, id) {
      if (id === 0) {
        return Restangular.one(model, id).customGET();
      }

      return Restangular.all(model).customGET(id);
    };

    this.getByParameter = function (model, message, paramObject) {
      return Restangular.all(model).customGET(message, paramObject);
    };

    this.post = function (model, data) {
      return Restangular.all(model).post(data);
    };
    this.put = function (model, data, id) {
      return Restangular.all(model).customPUT(data, id);
    };

    this.delete = function (model, params) {
      return Restangular.all(model).customOperation('remove', '', '', '', params);
    };

    this.customGET = function (model, message, id) {
      return Restangular.all(model).customGET(message, id);
    };

  });

/**
 * A utility service to cache the data
 *
 * Created by cxh on 1/13/2015.
 */
'use strict';
angular.module('dsaComponents')
  .service('dataContainerService', function (Restangular, crudService, $q, $filter) {

    var maxCacheAge = 60 * 60 * 1000; // 1 Hour in milliseconds
    var dataCache = {}; // holds cache entries like {key: {timestamp: momentInstance, data: array_of_row_objects}}
    /**
     * add new element to the cached array
     *
     * @param key         the key name of cached map
     * @param newElement  the new element
     */
    this.addElementToCache = function (key, newElement, dataIndex, sorter) {
      var cacheEntry = dataCache[key];
      if (!cacheEntry) {
        cacheEntry = {
          timestamp: moment(), // now
          data: [[]]
        };

        dataCache[key] = cacheEntry;
      }

      if (dataIndex === undefined || dataIndex === null) {
        cacheEntry.data.unshift(newElement);
      } else if (cacheEntry.data.length > dataIndex) {
        cacheEntry.data[dataIndex].unshift(newElement);
      }
      if (_.isFunction(sorter)) {
        var tempArr = [];
        tempArr = sorter(cacheEntry.data[dataIndex]);
        cacheEntry.data[dataIndex] = tempArr;
        //console.log(cacheEntry.data[dataIndex]);
      }
    };

    /**
     * Get all the cache
     * @returns {{}}
     */
    this.getAllCache = function () {
      return dataCache;
    };

    this.getCache = function (key, dataIndex) {
      var cacheEntry = dataCache[key];
      if (!cacheEntry) {
        return null;
      }

      if (dataIndex === undefined || dataIndex === null) {
        return cacheEntry.data;
      } else {
        return cacheEntry.data[dataIndex];
      }
    };

    function internalEditElementCache(key, newData, dataFinder, dataIndex, isDelete) {
      var cacheEntry = dataCache[key];
      if (cacheEntry) {

        var dataArray = cacheEntry.data;
        if (dataIndex !== undefined && dataIndex !== null) {
          dataArray = cacheEntry.data[dataIndex];
        }

        for (var i = 0; i < dataArray.length; i++) {
          var cacheData = dataArray[i];
          if (dataFinder.isMatch(cacheData) === true) {
            dataArray.splice(i, 1);
            if (!isDelete) {
              dataArray.splice(i, 0, newData);
            }
            break;
          }
        }
      }
    }

    /**
     * update the cached element
     *
     * @param key           the key name of cached map
     * @param dataFinder    function to find the old data element
     */
    this.updateElementCache = function (key, newData, dataFinder, dataIndex) {
      internalEditElementCache(key, newData, dataFinder, dataIndex, false);
    };

    /**
     * remove the cached element
     *
     * @param key           the key name of cached map
     * @param dataFinder    function to find the old data element
     */
    this.removeElementCache = function (key, dataFinder, dataIndex) {
      internalEditElementCache(key, null, dataFinder, dataIndex, true);
    };

    /**
     * clean cache of one key
     *
     * @param key the key name of cached map
     */
    this.cleanCache = function (key) {
      var cacheEntry = dataCache[key];
      if (cacheEntry) {
        cacheEntry.data = [];
        dataCache[key] = null;
      }
    };

    /**
     * clean all cache
     */
    this.cleanAllCache = function () {
      dataCache = {};
    };

    /**
     * get data from cache, call loader to load the data if not exist
     *
     * @param key         the key name of cached map
     * @param dataLoader  to be called to load the data
     * @param doRefresh   true will clean the cache and reload
     * @returns           a array of objects
     */
    this.getData = function (key, dataLoader, doRefresh) {
      // Create a promise.
      var deferred = $q.defer();

      var cacheEntry = dataCache[key];
      if (doRefresh || cacheEntry && cacheEntry.timestamp.diff(moment()) > maxCacheAge) {
        cacheEntry = null;
      }

      var findData = true;

      if (cacheEntry) {
        deferred.resolve(cacheEntry.data);
      } else {
        cacheEntry = {
          timestamp: moment(), // now
          data: []
        };

        if (dataLoader) {
          dataLoader.load().then(
            function (dataFromServer) {
              // Store the items in the cache.
              if (dataFromServer === undefined) {
                //server return null data
                deferred.resolve(undefined);
              } else {
                if (dataFromServer.data === undefined) {
                  //Restangular
                  cacheEntry.data = dataFromServer;
                } else {
                  //$http
                  cacheEntry.data = dataFromServer.data;
                }
                dataCache[key] = cacheEntry;

                // Resolve the promise.
                deferred.resolve(cacheEntry.data);
              }
            },
            function (response) {
              findData = false;
              // Reject the promise.
              deferred.reject(response);
            });
        } else {
          deferred.resolve(cacheEntry.data);
        }
      }

      // Return a promise that asynchronously loads the data.
      return deferred.promise;
    };
    this.getRefreshTimeStamp = function (key) {
      var cacheEntryDetails = dataCache[key];
      var date = $filter('date')(cacheEntryDetails.timestamp._d, 'dd-MM-yyyy');
      var time = get24HourTimeformat($filter('date')(cacheEntryDetails.timestamp._d, 'hh:mm:ss'));
      return date + ' ' + time;
    };

    function get24HourTimeformat(time) {
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      time[1] = new Date().getHours();
      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      }
      return time.join('');
    }
  });


/**
 * Created by rak on 12/17/2014.
 */
'use strict';
angular.module('dsaComponents').directive('focusOn', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
  return function focusOn(scope, element, attr) {
    var setFocus = function () {
      $timeout(function () {
        element[0].focus();
        if (attr.jqxNgModel === 'comboBox') {
          $('#' + element[0].id).jqxComboBox('focus');
        } else if (attr.id !== undefined && attr.id.toLowerCase().indexOf('combobox') !== -1) {
          $('#' + element[0].id).jqxComboBox('focus');
        } else if (element[0].classList.contains('jqx-input')) {
          $('#' + element[0].id).jqxInput('focus');
        }
      });
    };

    //works only if val is set false between focus
    scope.$watch(attr.focusOn, function (val) {
      if (val) {
        $timeout(function () {
          if (element[0].nodeName === 'TABLE') {
            var table = element[0].children[0];
            if (table !== undefined && table !== null) {
              var tr = table.children[1];
              if (tr !== undefined && tr !== null) {
                var input = (tr.children[0]).children[0];
                if (input !== undefined && input !== null) {
                  input.focus();
                }
              }
            }
          } else {
            scope.$watch('dataLoadingFinished',
              function (loadingFinished) {
                if (loadingFinished) {
                  setFocus();
                }
              });
            setFocus();
          }
        });

      }
    });

    //works multiple times is triggered with $scope.$broadcast('elemenid');
    scope.$on(attr.focusOn, function () {
      setFocus();
    });

    var rootScopeListener = $rootScope.$on(attr.focusOn, function () {
      $timeout(function () {
        setFocus();
      }, 5);
    });

    scope.$on('$destroy', function () {
      rootScopeListener();
    });
  };
}]);

/**
 * Created by rak on 28/03/2017.
 */
'use strict';

angular.module('dsaComponents')
  .service('dashboardService', function () {
    this.getDashboardWidget = function (dashBoardModel, type) {
      for (var i = 0; i < dashBoardModel.rows.length; i++) {
        for (var j = 0; j < dashBoardModel.rows[i].columns.length; j++) {
          if (dashBoardModel.rows[i].columns[j].widgets) {
            for (var k = 0; k < dashBoardModel.rows[i].columns[j].widgets.length; k++) {
              if (dashBoardModel.rows[i].columns[j].widgets[k].type === type) {
                return dashBoardModel.rows[i].columns[j].widgets[k];
              }
            }
          }
          if (dashBoardModel.rows[i].columns[j].rows && dashBoardModel.rows[i].columns[j].rows.length > 0) {
            for (var l = 0; l < dashBoardModel.rows[i].columns[j].rows.length; l++) {
              for (var m = 0; m < dashBoardModel.rows[i].columns[j].rows[l].columns.length; m++) {
                if (dashBoardModel.rows[i].columns[j].rows[l].columns[m].widgets) {
                  for (var n = 0; n < dashBoardModel.rows[i].columns[j].rows[l].columns[m].widgets.length; n++) {
                    if (dashBoardModel.rows[i].columns[j].rows[l].columns[m].widgets[n].type === type) {
                      return dashBoardModel.rows[i].columns[j].rows[l].columns[m].widgets[n];
                    }
                  }
                }
              }
            }
          }
        }
      }
      return false;
    };

  });

/**
 * Created by cxh on 12/2/2015.
 */
'use strict';


angular.module('dsaComponents')
  .service('languageService', function (localStorageService) {

    this.getLanguageSettings = function () {
      var languageSettings = {
        language: ''
      };
      var languageSettingsInStore = localStorageService.get('languageSettings');
      if (languageSettingsInStore !== null) {
        languageSettings = {
          language: languageSettingsInStore.language !== null ? languageSettingsInStore.language : ''
        };
      } else {
        languageSettings.language = 'en';
        this.saveLanguageSettings(languageSettings);
      }
      return languageSettings;
    };

    this.saveLanguageSettings = function (newLanguageSetting) {
      localStorageService.set('languageSettings', newLanguageSetting);
    };

    this.getLocale = function (language) {
      var locale = 'en-US';

      switch (language) {
        case 'en':
          locale = 'en-US';
          break;
        case 'de':
          locale = 'de-DE';
          break;
        default:
          locale = 'en-US';
      }

      return locale;
    };

  });


'use strict';

angular.module('dsaComponents')
  .directive('dsaLogin', function () {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'login/dsalogin.tpl.html',
      scope: {
        title: '@title',
        loginIDString: '@loginid'
      },
      controller: function ($attrs, $scope, $uibModal, $rootScope, $location, errorHandlingService, AuthenticationService, usSpinnerService, $translate, $state, dsaComponentsConfig, accountConfig) {
        $scope.loginID = JSON.parse($scope.loginIDString.replace(/'/g, '"'));

        //Ensure accountID Available is set to false by default
        $scope.accountIDAvailable = false;
        var accountID = window.location.hostname.split('.')[0];
        if(accountID in accountConfig.imprintUrls) {
          $scope.accountIDAvailable = true;
        }

        if (dsaComponentsConfig.customLoginID) {
          dsaComponentsConfig.customLoginID($scope.loginID);
        }

        $scope.credentials = {
          password: ''
        };

        var isLoginIDNotEmpty = function () {
          var isNotEmpty = true;

          _.forIn($scope.loginID, function (value) {
            if (!value || value === '') {
              isNotEmpty = false;
              //break the loop
              return false;
            }
          });

          return isNotEmpty;
        };

        $scope.forgotPassword = function () {
          //User clicks forgot password button
          //This must open the forgot password dialog
          $uibModal.open({
            templateUrl: 'login/dsaForgotPassword.tpl.html',
            controller: 'ForgotPasswordCtrl',
            restrict: 'E',
            transclude: true,
            resolve: {
              loginIDString: function () {
                return $scope.loginID;
              }
            }
          });
        }

        $scope.login = function () {
          $scope.dataLoading = true;
          var accountID = window.location.hostname.split('.')[0];
          if(accountID in accountConfig.imprintUrls) {
            $scope.loginID.Account = accountID;
          }
          
          if (isLoginIDNotEmpty() && $scope.credentials.password !== '') {

            usSpinnerService.spin('loginSpinner');
            AuthenticationService.Login($scope.loginID, $scope.credentials.password)
              .then(function () {
                //Login Message could be waiting
                //If there is a login message then display
                if ($rootScope.globals.currentUser.loginMessage && $rootScope.globals.currentUser.loginMessage !== '') {
                  errorHandlingService.showJqxNotificationInfo($rootScope.globals.currentUser.loginMessage);
                }

                var returnToState = $rootScope.returnToState;
                var returnToStateParams = $rootScope.returnToStateParams;
                $rootScope.returnToState = null;
                $rootScope.returnToStateParams = null;
                if (returnToState) {
                  $state.go(returnToState, returnToStateParams);
                } else {
                  if (dsaComponentsConfig.loginSuccessState) {
                    $state.go(dsaComponentsConfig.loginSuccessState);
                  }
                  else {
                    $location.path('/');
                  }
                }
              }, function (errResponse) {
                var status = errResponse.status;
                var data = errResponse.data;
                if (status <= 0) {
                  $scope.error = $translate.instant('login.error.timeout');
                } else if (status === 500) {
                  $scope.error = $translate.instant('serverMessage.internalServerError');
                } else {
                  var errorCode = '';

                  if (data[0]) {
                    errorCode = data[0].message;

                    try {
                      errorCode = JSON.parse(errorCode);

                      // if errorcode is PE0010 Password expired, show password expired screen
                      // provide dialog to enter a new password
                      if (errorCode.errors[0].code && errorCode.errors[0].code === 'PE0010') {
                        AuthenticationService.setCredentialsExtern($scope.loginID, $scope.credentials.password);
                        var modalInstance = $uibModal.open({
                          templateUrl: 'components/login/pswdChange.tpl.html',
                          controller: 'passwordController',
                          size: 'md',
                          resolve: {
                            errorCode: function () {
                              return errorCode.errors[0].code;
                            }
                          }
                        });
                        modalInstance.result.then(function (password) {
                          if (password !== '') {
                            $scope.credentials.password = password;
                            $scope.login();
                          }
                        });
                        return;
                      }

                      if(errorCode.errors[0].code) {
                        // First try to use error code to get a i18n text for this (based on error code).
                        var key = 'serverMessage.login.' + errorCode.errors[0].code;
                        $scope.error = $translate.instant(key);
                        if ($scope.error !== key) {
                          return; // Translation found. Return.
                        }
                      }
                      if (errorCode.message) {  //error message from betotrack, see bug bs-432 - 55
                        $scope.error = errorCode.message;
                        return;
                      }
                    } catch (err) {
                      //do nothing
                    }
                  } else if (data.errors[0]) {
                    errorCode = data.errors[0].code;
                  }
                  $scope.error = $translate.instant('serverMessage.login.' + errorCode);
                }
              }).finally(function () {
                usSpinnerService.stop('loginSpinner');
              });

          }
          else {
            $scope.error = ' please fill the required fields ';
          }

        };
        $scope.onKeyPress = function ($event) {
          if ($event.keyCode === 13) {
            // Here is where I must fire the click event of the button
            $scope.login();
          }
        };
      }
    };
  });

angular.module('dsaComponents')
  .controller('ForgotPasswordCtrl', function ($scope, loginIDString, $uibModalInstance, AuthenticationService, $window, $translate, $q, dsaComponentsConfig) {
    $scope.title = $translate.instant('forgotPassword.title');
    $scope.loginID = loginIDString;
    var errorAlert = null;
    $scope.alerts = [];

    $scope.credentials = {
      email: ''
    };

    var isLoginIDNotEmpty = function () {
      var isNotEmpty = true;

      _.forIn($scope.loginID, function (value) {
        if (!value || value === '') {
          isNotEmpty = false;
          //break the loop
          return false;
        }
      });

      return isNotEmpty;
    };

    $scope.submit = function () {
      $scope.alerts = [];
      $scope.dataLoading = true;
      if (($scope.credentials.email && $scope.credentials.email !== '' && isLoginIDNotEmpty())) {
        AuthenticationService.forgotPassword($scope.loginID, $scope.credentials.email).then(function () {
          var successAlert = { type: 'success', msg: $translate.instant('passwordChange.successForgotPassword'), autoDismiss: true };
          $scope.alerts.push(successAlert);
        }, function (response) {
          if (response.data) {
            errorAlert = { type: 'error', msg: response.data.message, autoDismiss: true };
            $scope.alerts.push(errorAlert);
          }
        });
      }
      else {
        errorAlert = { type: 'error', msg: $translate.instant('passwordChange.requiredField'), autoDismiss: true };
        $scope.alerts.push(errorAlert);
      }
    }

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.onKeyPress = function ($event) {
      if ($event.keyCode === 13) {
        // Here is where I must fire the click event of the button
        $scope.submit();
      }
    };

    $scope.closeAlertByIndex = function (index) {
      $scope.alerts.splice(index, 1);
    };
  });


/**
 * Created by ejb on 12/5/2015.
 */

'use strict';
angular.module('dsaComponents')
  .run(['$rootScope', '$timeout', '$state', '$filter', function ($rootScope, $timeout, $state, $filter) {

    $rootScope.$on('$stateChangeSuccess', function () {

      var title = $state.$current.locals.globals.$title;
      var translatedTitle = '';

      var $translate = $filter('translate');

      if (!angular.isDefined(title)) {
        //Default title which is set if title is not set in state provider
        translatedTitle = 'DSA';
        $rootScope.$title = translatedTitle;
      }


      if (angular.isArray(title)) {
        //title is an array which is translated step by step
        var i;

        for (i = 0; i < title.length; i++) {
          if (i === 0) {
            translatedTitle = $translate(title[i]);
          } else {
            translatedTitle = translatedTitle + ' > ' + $translate(title[i]);
          }
        }

      } else {
        //title is simple string
        translatedTitle = $translate(title);
      }

      if (translatedTitle) {
        $timeout(function () {
          //title is set in $rootScope
          $rootScope.$title = translatedTitle;
        });
      }

    });

  }]);

/**
 * Created by rak on 7/4/2017.
 */

'use strict';
angular.module('dsaComponents')
  .service('userPreferenceService', function ($window, $cookies, crudService, localStorageService, AuthenticationService, dsaComponentsConfig, localStoragePrefix, $q) {
    this.clearLocalStroageAndCookies = function () {
      var keys = Object.keys($window.localStorage);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(dsaComponentsConfig.localStoragePrefix) > -1) {
          $window.localStorage.removeItem(keys[i]);
        }
      }
      var cookies = $cookies.getAll();
      _.each(cookies, function (v, k) {
        if (k.toLowerCase().indexOf(dsaComponentsConfig.localStoragePrefix.toLowerCase()) > -1) {
          $cookies.remove(k);
        }
      });
      var deferred = $q.defer();
      deferred.resolve({});
      return deferred.promise;
    };

    this.restoreLocalStorage = function () {
      return crudService.get('user/userpreferencesettings').then(function (userPreferenceSettngs) {
        var userPrefrences = JSON.parse(userPreferenceSettngs.localStorageSetting);
        var cokieSettings = JSON.parse(userPreferenceSettngs.cookieSettings);

        if (cokieSettings !== null) {
          var cookieKey = Object.keys(cokieSettings);

          if (cookieKey.length) {
            // Bug 94527 , Bug 95555
            for (var j = 0; j < cookieKey.length; j++) {
              var key = cookieKey[j];
              var value = cokieSettings[key];

              if (key !== (dsaComponentsConfig.productName + '.' + dsaComponentsConfig.moduleName) && key !== (dsaComponentsConfig.productName)) {
                $cookies.remove(key);// remove if already contains
                if (typeof value === 'string') { // can be string if window reload is used
                  value = JSON.parse(value);
                }
                $cookies.putObject(key, value);
              }
            }
          }
        }

        var prefrenceKeys = Object.keys(userPrefrences);
        if (prefrenceKeys.length) {
          for (var i = 0; i < prefrenceKeys.length; i++) {
            var prefKey = prefrenceKeys[i];
            var prefValue = userPrefrences[prefKey];
            $window.localStorage.removeItem(prefKey);
            $window.localStorage.setItem(prefKey, prefValue);
          }

        }
      });
    };

    this.saveLocalStorage = function () {
      var keys = Object.keys($window.localStorage);
      var i = keys.length;
      var isFound = false;
      var localStorageObjectCopy = _.extend({}, $window.localStorage);
      var userName = AuthenticationService.GetLoginID();
      var userPrefrence = {
        userName: userName.username || userName,
        localStorageSetting: ''

      };
      while (i--) {
        if (keys[i].indexOf(dsaComponentsConfig.localStoragePrefix) > -1) {
          isFound = true;
        } else {
          isFound = hasCommonLocalStorageSettings(keys[i]);
        }

        if (!isFound) {
          delete localStorageObjectCopy[keys[i]];
        }
      }

      var cookies = $cookies.getAll();
      _.each(cookies, function (v, k) {
        if (k.toLowerCase().indexOf(localStoragePrefix.toLowerCase()) === -1) {
          delete cookies[k];
        }
      });
      userPrefrence.cookieSettings = JSON.stringify(cookies);
      userPrefrence.localStorageSetting = JSON.stringify(localStorageObjectCopy);
      return crudService.post('user/userpreferencesettings', userPrefrence);
    };

    function hasCommonLocalStorageSettings(key) {
      if (key.indexOf('.version') > -1) {
        return true;
      }
      if (key.indexOf('.languageSettings') > -1) {
        return true;
      }
      return false;
    }

  });

/**
 * Created by rak on 12/06/2018.
 */

'use strict';
angular.module('dsaComponents')
  .directive('scrollToTop', function ($window, $document) {

    var directive = {
      scope: {},
      restrict: 'AE',
      template: '<div class="scroll-top-wrapper">' +
        '<span class="scroll-top-inner">' +
        '<i class="fa fa-2x fa-arrow-circle-up"></i>' +
        '</span>' +
        '</div>',
      link: function () {

        $document.on('scroll', function () {
          if ($window.scrollY > 100) {
            $('.scroll-top-wrapper').addClass('show');
          } else {
            $('.scroll-top-wrapper').removeClass('show');
          }
        });
        $('.scroll-top-wrapper').on('click', scrollToTop);


        function scrollToTop() {
          $('html, body').animate({ scrollTop: 0 }, 500, 'linear');
        }
      }
    };

    return directive;
  });

/**
 * Created by cxh on 3/2/2016.
 */

'use strict';

angular.module('dsaComponents')

  .service('webSocketService', function (serverBaseUrl, dsaComponentsConfig, $cookies, $http, $q, $interval, $location) {

    var reconnectInterval = 30000;
    var stompClient;
    var subscriber;
    var listener = $q.defer();
    var connected;
    var alreadyConnectedOnce;
    var forceDisconnect = false;
    var intervalObj = null;

    var lastClientID;
    var lastSubscribeID;

    function init() {
      stompClient = null;
      subscriber = null;
      connected = $q.defer();
      alreadyConnectedOnce = false;
    }

    init();

    this.connect = function (clientID) {
      forceDisconnect = false;

      if (stompClient !== null) {
        return;
      }
      var self = this;
      //building absolute path so that webSocket does not fail when deploying with a context path
      var path = $location.absUrl().split('#')[0].replace('index.html', '');
      var url;
      if (dsaComponentsConfig.moduleName) {
        url = path + dsaComponentsConfig.moduleName + '/' + serverBaseUrl + '/' + dsaComponentsConfig.webSocketUrl;
      } else {
        if (path.indexOf(dsaComponentsConfig.productName.toLowerCase()) === -1) {
          url = path + dsaComponentsConfig.productName.toLowerCase() + '/' + serverBaseUrl + '/' + dsaComponentsConfig.webSocketUrl;
        } else {
          url = path + serverBaseUrl + '/' + dsaComponentsConfig.webSocketUrl;
        }
      }
      var socket = new SockJS(url, null, { transports: ['websocket'] });
      stompClient = Stomp.over(socket);
      var headers = $http.defaults.headers.common;
      headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
      if (clientID) {
        headers['client-id'] = clientID;
      }

      lastClientID = clientID;
      stompClient.connect(headers, function () {
        connected.resolve('success');

        if (!alreadyConnectedOnce) {
          alreadyConnectedOnce = true;
        }
      }, function () {
        //reconnect
        if (!forceDisconnect) {
          if (intervalObj) {
            $interval.cancel(intervalObj);
          }
          intervalObj = $interval(function () {
            if (!forceDisconnect) {
              init();
              self.connect(lastClientID);
              self.subscribe(lastSubscribeID, lastClientID);
            }
          }, reconnectInterval, 1);
        }
      });
    };

    this.subscribe = function (subscribeID, clientID) {
      lastSubscribeID = subscribeID;
      connected.promise.then(function () {
        if (subscriber === null) {
          var headers = {};
          if (clientID) {
            headers = { 'activemq.subscriptionName': clientID };
          }
          subscriber = stompClient.subscribe(subscribeID, function (data) {
            listener.notify(data);
          }, headers);
        }
      }, null, null);
    };

    this.unsubscribe = function () {
      if (subscriber !== null) {
        subscriber.unsubscribe();
      }
    };

    this.receive = function () {
      return listener.promise;
    };

    this.disconnect = function () {
      if (stompClient !== null && stompClient.connected) {
        stompClient.disconnect();
      }

      forceDisconnect = true;

      init();
    };
  });

/**
 * Created by zhj on 2/2/2015.
 */
'use strict';

angular.module('dsaComponents')
  .service('versionService', function (Restangular) {
    this.getVersion = function () {
      return Restangular.all('version').customGET();
    };
  });

/**
 * Created by cxh on 03/09/2015.
 */
'use strict';


angular.module('dsaComponents')
  .service('widgetSettingsCreatorService', function (dsaComponentsConfig, languageService, $uibModal) {
    this.createComboxSettings = function (customProperties, isCustomizedRender) {
      var settings = {
        width: '100%',
        height: dsaComponentsConfig.jqxDefaultSetting.comboxHeight,
        theme: dsaComponentsConfig.jqxCustomSettings.theme,
        searchMode: 'containsignorecase',
        autoComplete: true,
        autoDropDownHeight: false
      };

      settings = _.extend(settings, customProperties);
      settings.bindingComplete = function () {
        if (settings.source !== undefined && settings.source !== null) {
          if (settings.source.length < 8) {
            settings.apply({ 'autoDropDownHeight': true });
          }
        }
      };

      if (isCustomizedRender) {
        settings.renderer = function (index, lable, value) {
          var table = '<table style="color: inherit; font-size: inherit; font-style: inherit;"><tr><td>' + value + '-' + lable + '</td></tr></table>';
          return table;
        };

        settings.renderSelectedItem = function (index, item) {
          return item.value + '-' + item.label;
        };
      }


      return settings;
    };

    this.fetchWidgetStyleSettings = function () {
      return dsaComponentsConfig.jqxCustomSettings;
    }

    this.fetchCustomerWidgetStyleSettings = function () {
      //default style settings
      var styles = {
        header: {
          class: 'jqx-widget-header '
        },
        row: {
          class: 'jqx-widget-content '

        }
      };

      //overide customer theme settings for material theme
      if (dsaComponentsConfig.jqxCustomSettings.theme === 'material') {
        styles.header.class += 'jqx-widget-header-material ';
        styles.row.class += 'jqx-widget-content-material ';
      }

      return styles;
    }


    this.getContextMenuCoordinate = function (event) {
      var coordinate = {
        clientX: 0,
        clientY: 0
      };
      var scrollTop = $(window).scrollTop();
      var scrollLeft = $(window).scrollLeft();
      var clientX = event.args !== undefined ? event.args.originalEvent.clientX : event.originalEvent.clientX;
      var clientY = event.args !== undefined ? event.args.originalEvent.clientY : event.originalEvent.clientY;
      if (scrollLeft !== undefined && scrollLeft !== null) {
        coordinate.clientX = parseInt(clientX) + 5 + scrollLeft;
      } else {
        coordinate.clientX = parseInt(clientX) + 5;
      }
      if (scrollTop !== undefined && scrollTop !== null) {
        coordinate.clientY = parseInt(clientY) + 5 + scrollTop;
      } else {
        coordinate.clientY = parseInt(clientY) + 5;
      }
      return coordinate;
    };

    this.createJqxMaskedInputSettings = function (customSettings) {
      var settings = {
        width: '97%',
        height: 20,
        mask: '+##-####-#######-###'
      };
      if (customSettings) {
        settings = _.extend(settings, customSettings
        );
      }
      return settings;
    };

    this.createJqxDateTimeSettings = function (customSettings) {
      var settings = {
        allowNullDate: true,
        formatString: 'HH:mm',
        showCalendarButton: false,
        theme: dsaComponentsConfig.jqxCustomSettings.theme, //'material', // theme: 'bootstrap',
        culture: 'de-DE',
        width: '98%',
        height: 22
      };
      if (customSettings) {
        settings = _.extend(settings, customSettings
        );
      }
      return settings;
    };
    var datePickerOptions = {
      'show-weeks': true,
      startingDay: 1
    };

    this.createDatePickerInstance = function (dateFormat) {
      return (function () {
        var method = {};
        method.instances = [];
        method.open = function ($event, instance) {
          $event.preventDefault();
          $event.stopPropagation();
          method.instances[instance] = true;
        };
        method.options = datePickerOptions;
        method.format = dateFormat;
        return method;
      }());
    };

    this.getDatePickerListOptions = function () {
      var customDatePickerOptions = {
        'show-weeks': true,
        startingDay: 1,
        initDate: new Date()
      };
      return customDatePickerOptions;
    };

    this.createCalendarSettings = function (customProperties) {
      var settings = {
        width: '100%',
        height: 260,
        titleHeight: 30,
        culture: 'en-US'
      };

      if (languageService.getLanguageSettings() && languageService.getLanguageSettings().language) {
        var language = languageService.getLanguageSettings().language;

        settings.culture = languageService.getLocale(language);
      }

      settings = _.extend(settings, customProperties);

      return settings;
    };


    this.openGridSettingDialog = function (modelName, gridName, service, additionalParameters) {
      $uibModal.open({
        templateUrl: 'widgetSettingsCreator/gridPreference/gridPreference.tpl.html',
        controller: 'GridPreferenceCtrl',
        resolve: {
          modelName: function () {
            return modelName;
          },
          gridName: function () {
            return gridName;
          },
          gridServiceArgs: function () {
            return service;
          },
          additionalParameters: function () {
            return additionalParameters;
          }
        }
      });
    };

    this.applyGridSettingToGrid = function (gridSettingId, userSettings, columnObj, columnName) {
      if (!userSettings) {
        return columnObj;
      }

      if (!userSettings.gridsSetting[gridSettingId]) {
        return columnObj;
      }

      if (userSettings.gridsSetting[gridSettingId].hidingColumns) {
        if (columnObj.hidden && !userSettings.gridsSetting[gridSettingId].hidingColumns.includes(columnName)) {
          delete columnObj.hidden;
        }
      }

      if (userSettings.gridsSetting[gridSettingId].hidingColumns) {
        for (var hideIndex in userSettings.gridsSetting[gridSettingId].hidingColumns) {
          if (columnName === userSettings.gridsSetting[gridSettingId].hidingColumns[hideIndex]) {
            columnObj.hidden = 'true';
            break;
          }
        }
      }

      if (userSettings.gridsSetting[gridSettingId].columnsOrders) {
        //set column order
        for (var showIndex = 0; showIndex < userSettings.gridsSetting[gridSettingId].columnsOrders.length; showIndex++) {
          if (userSettings.gridsSetting[gridSettingId].columnsOrders[showIndex] && (columnName === userSettings.gridsSetting[gridSettingId].columnsOrders[showIndex].name)) {
            columnObj.index = showIndex;
            break;
          }
        }
      }

      if (userSettings.gridsSetting[gridSettingId].frozenColumns) {
        for (var pinnedIndex in userSettings.gridsSetting[gridSettingId].frozenColumns) {
          if (userSettings.gridsSetting[gridSettingId].frozenColumns[pinnedIndex] && (columnName === userSettings.gridsSetting[gridSettingId].frozenColumns[pinnedIndex].name)) {
            columnObj.pinned = true;
            break;
          }
        }
      }

      if (userSettings.gridsSetting[gridSettingId].backgroundColor) {
        columnObj.cellclassname = 'rgb-' + userSettings.gridsSetting[gridSettingId].backgroundColor;
      }
      return columnObj;
    };

    /**
     * User drag column, rebuild the columns order in userSetting.
     * 1. there is no grid setting in userSertting , return null.
     *    else return New UserSetting with the new column orders
     * @param userSetting  old user setting
     * @param gridIdentifierName  grid identifierName which was changed
     * @param eventArgs  drag event arguments
     */
    this.rebuildDragColumnsOrder = function (userSetting, gridIdentifierName, eventArgs) {
      if (!userSetting.gridsSetting[gridIdentifierName]) {
        return null;
      }

      var columnsOrder = userSetting.gridsSetting[gridIdentifierName].columnsOrders;
      if (!columnsOrder) {
        return null;
      }
      var temp;
      if (eventArgs.oldindex > eventArgs.newindex) {  //move ahead
        temp = columnsOrder[eventArgs.oldindex];
        if (!temp) {
          return null;
        }
        for (var i = eventArgs.oldindex; i > eventArgs.newindex; i--) {
          columnsOrder[i] = columnsOrder[i - 1];
        }
        columnsOrder[eventArgs.newindex] = temp;
      } else {
        temp = columnsOrder[eventArgs.oldindex];
        if (!temp) {
          return null;
        }
        for (var j = eventArgs.oldindex; j < eventArgs.newindex; j++) {
          columnsOrder[j] = columnsOrder[j + 1];
        }
        columnsOrder[eventArgs.newindex] = temp;
      }
      userSetting.gridsSetting[gridIdentifierName].columnsOrders = columnsOrder;
      return userSetting;
    };

  });

/**
 * Created by linli on 5/25/2016.
 *
 * 2017-3-28 13:53:07 fky
 * parameter: gridServiceArgs is a service must implement following method:
 *           a. getUserSettings()
 *           b. saveUserSettings(settings)
 *           c. removeGridStateStorage(modelName,gridName)
 *           d. getOverviewListSettings(modelName)
 *
 */
'use strict';

angular.module('dsaComponents')
  .controller('GridPreferenceCtrl', function ($scope, $uibModalInstance, gridServiceArgs, $window, $translate, modelName, gridName, additionalParameters, $q, dsaComponentsConfig, accountConfig) {
    var userSettings = gridServiceArgs.getUserSettings();

    var gridSettingId = modelName ? modelName + '-' + gridName : gridName;
    var gridIdentifierName;
    if (modelName) {
      var specifiedGridName = gridName !== modelName ? gridName : '';
      if (additionalParameters && additionalParameters.additionalCustomProperties && additionalParameters.additionalCustomProperties.isDynamicGrid) {
        gridIdentifierName = specifiedGridName.replace('_' + dsaComponentsConfig.localStoragePrefix + '_', '');
      } else {
        gridIdentifierName = modelName + specifiedGridName + 'List';
      }
    } else {
      gridIdentifierName = gridName.replace('_' + dsaComponentsConfig.localStoragePrefix + '_', '');
    }
    $scope.frozenColumns = 0;
    if (!userSettings.gridsSetting[gridSettingId]) {
      userSettings.gridsSetting[gridSettingId] = {};
      gridServiceArgs.saveUserSettings(userSettings);
    }
    if (additionalParameters) {
      $scope.modelTranslatePath = additionalParameters.additionalCustomProperties.translatedName || '';
    } else {
      $scope.modelTranslatePath = modelName + 'List.moduleName';
    }

    //color picker start
    var getTextElementByColor = function (color) {
      if (color === 'transparent' || color.hex === '') {
        return $('<div style="text-shadow: none; position: relative; padding-bottom: 2px; margin-top: 2px;">transparent</div>');
      }

      var element = $('<div style="text-shadow: none; position: relative; padding-bottom: 2px; margin-top: 2px;">#' + color.hex + '</div>');
      var nThreshold = 105;
      var bgDelta = (color.r * 0.299) + (color.g * 0.587) + (color.b * 0.114);
      var foreColor = (255 - bgDelta < nThreshold) ? 'Black' : 'White';
      element.css('color', foreColor);
      element.css('background', '#' + color.hex);
      element.addClass('jqx-rc-all');
      return element;
    };

    $scope.createColorPicker = false;
    $scope.colorPickerButtonInstance = {};

    $scope.openColorPicker = function () {
      $scope.createColorPicker = true;
    };

    $scope.colorChange = function (event) {
      $scope.colorPickerButtonInstance.setContent(getTextElementByColor(event.args.color));
      userSettings.gridsSetting[gridSettingId].backgroundColor = event.args.color.hex;
    };

    $scope.$on('jqxDropDownButtonCreated', function () {
      if (userSettings.gridsSetting[gridSettingId].backgroundColor) {
        $scope.colorPickerButtonInstance.setContent(getTextElementByColor(new $window.$.jqx.color({ hex: userSettings.gridsSetting[gridSettingId].backgroundColor })));
      }
    });
    //color picker end

    $scope.showingList = [];
    $scope.hidingList = [];

    var isTranslated = false;
    var _oldFrozenCount = null;
    var loadingColumnsSource = function () {
      loadingHidingColumns();

      getShownColumnsOfOverviewListSettings(additionalParameters).then(function (shownColumns) {

        if (userSettings.gridsSetting[gridSettingId]) {
          userSettings.gridsSetting[gridSettingId].hidingColumns = []; // only rest hiding column not the whole object
        }

        var gridSetting = $window.localStorage['jqxGrid_' + dsaComponentsConfig.localStoragePrefix + '_' + gridIdentifierName];
        if (gridSetting) {
          var gridSettingJson = $.parseJSON(gridSetting);
          if (gridSettingJson && gridSettingJson.columns) {
            for (var column in gridSettingJson.columns) {
              var shownColumn = shownColumns[column];

              if (shownColumn) {
                $scope.showingList.push(shownColumn);

                if (gridSettingJson.columns[column].hidden && $scope.hidingList.indexOf(shownColumn.name) === -1) {
                  $scope.hidingList.push(shownColumn.name);
                  userSettings.gridsSetting[gridSettingId].hidingColumns.push(shownColumn.name);
                }
              }
              if (gridSettingJson.columns[column].pinned) {
                $scope.frozenColumns++;
              }
            }
          }
        } else {
          loadFrozenColumns();
          var hiddenColumns = (_.values(shownColumns).filter(function (column) {
            return column.hidden === 'true';
          }).map(function (column) {
            return column.name;
          }));

          $scope.showingList = $scope.showingList.concat(_.values(shownColumns));
          $scope.hidingList = $scope.hidingList.concat(hiddenColumns);
          $scope.hidingList = _.uniq($scope.hidingList);
          userSettings.gridsSetting[gridSettingId].hidingColumns.push($scope.hidingList);

          //loadingHidingColumns();
          //reorderColumnByUsersetting($scope.showingList);
        }
      }).finally(function () {
        _oldFrozenCount = $scope.frozenColumns;
      });
    };


    /**
     * Order the showing list column by customer setting.
     * @param showListArray   $scope.showingList
     */
    // var reorderColumnByUsersetting = function (showListArray) {
    //   var oldOrderList = userSettings.gridsSetting[gridSettingId].columnsOrders;
    //   if (oldOrderList) {
    //     for (var i = 0; i < oldOrderList.length; i++) {
    //       for (var j = 0; j < showListArray.length; j++) {
    //         if(_.isEqual(oldOrderList[i],showListArray[j])){
    //           if(i !== j) {
    //             var temp = showListArray[i];
    //             if(temp){
    //               showListArray[i] = showListArray[j];
    //               showListArray[j] = temp;
    //             }
    //           }
    //           break;
    //         }
    //       }
    //     }
    //   }
    // };

    var getShownColumnsOfOverviewListSettings = function (additionalParameters) {
      if (additionalParameters) {
        var columns = {};
        var columnsList = additionalParameters.columns;
        for (var i = 0; i < columnsList.length; i++) {
          columns[columnsList[i].datafield] = {
            name: columnsList[i].datafield,
            text: columnsList[i].text.replace(/\\n/gm, ' '),
            hidden: columnsList[i].hidden
          };
        }

        isTranslated = true;

        var deferred = $q.defer();
        deferred.resolve(columns);
        return deferred.promise;
      } else {
        return gridServiceArgs.getOverviewListSettings(modelName).then(function (overviewListSettings) {
          var columns = {};
          if (overviewListSettings && overviewListSettings.overviewListGrids) {
            var overviewListGrids = overviewListSettings.overviewListGrids;
            for (var gridIndex in overviewListGrids) {
              var overviewListGrid = overviewListGrids[gridIndex];
              if (overviewListGrid && overviewListGrid.columnProperties &&
                (!overviewListGrid.gridName || (overviewListGrid.gridName && overviewListGrid.gridName.indexOf(gridName)) !== -1)) {
                for (var columnIndex in overviewListGrid.columnProperties) {
                  var column = overviewListGrid.columnProperties[columnIndex];
                  if (!column.isHidden) {
                    var translatePath = 'listView.' + modelName + '.headers.' + column.name;
                    columns[column.name] = { name: column.name, text: $translate.instant(translatePath) };
                  }
                }
              }
            }
          }

          return columns;
        });
      }
    };

    var loadingHidingColumns = function () {
      for (var index in userSettings.gridsSetting[gridSettingId].hidingColumns) {
        $scope.hidingList.push(userSettings.gridsSetting[gridSettingId].hidingColumns[index]);
      }

      $scope.hidingList = _.uniq($scope.hidingList);
    };

    var loadFrozenColumns = function () {
      if (userSettings.gridsSetting[gridSettingId].frozenColumns) {
        $scope.frozenColumns = userSettings.gridsSetting[gridSettingId].frozenColumns.length;
      }

      // $scope.frozenColumns = _.uniq($scope.frozenColumns);
    };
    loadingColumnsSource();

    var isShowing = function (item) {
      for (var hidingIndex in $scope.hidingList) {
        if ($scope.hidingList[hidingIndex] === item.name) {
          return false;
        }
      }
      return true;
    };
    $scope.columnsListBoxSettings =
    {
      width: '100%',
      height: 200,
      checkboxes: true,
      multiple: false,
      enableHover: false,
      source: function () {
        var listSource = [];
        for (var index in $scope.showingList) {
          if (modelName && !isTranslated) {
            var translatePath = 'listView.' + modelName + '.headers.' + $scope.showingList[index].name;
            listSource.push({
              label: $translate.instant(translatePath),
              value: $scope.showingList[index].name,
              checked: isShowing($scope.showingList[index])
            });
          } else {
            listSource.push({
              label: $scope.showingList[index].text,
              value: $scope.showingList[index].name,
              checked: isShowing($scope.showingList[index])
            });
          }
        }
        return listSource;
      }
    };

    $scope.onCheckChange = function (event) {
      var args = event.args;
      if (args && args.item) {
        if (event.args.checked) {
          for (var index in $scope.hidingList) {
            if (args.item.value === $scope.hidingList[index]) {
              $scope.hidingList.splice(index, 1);
              break;
            }
          }
        } else {
          $scope.hidingList.push(args.item.value);
        }
      }
    };

    $scope.moveUp = function () {
      var selectIndex = $window.$('#columnsListBox').jqxListBox('getSelectedIndex');
      if (selectIndex === -1 || selectIndex === 0) {
        return;
      }
      moveArrayIndex($scope.showingList, selectIndex, 0);
      $window.$('#columnsListBox').jqxListBox('refresh');
      $window.$('#columnsListBox').jqxListBox('selectIndex', selectIndex - 1);
      $window.$('#columnsListBox').jqxListBox('ensureVisible', selectIndex - 1);
    };

    $scope.moveDown = function () {
      var selectIndex = $window.$('#columnsListBox').jqxListBox('getSelectedIndex');
      if (selectIndex === -1 || selectIndex === $scope.showingList.length - 1) {
        return;
      }
      moveArrayIndex($scope.showingList, selectIndex, 1);
      $window.$('#columnsListBox').jqxListBox('refresh');
      $window.$('#columnsListBox').jqxListBox('selectIndex', selectIndex + 1);
      $window.$('#columnsListBox').jqxListBox('ensureVisible', selectIndex + 1);
    };


    $scope.save = function () {
      for (var index in $scope.hidingList) {
        if (userSettings.gridsSetting[gridSettingId].hidingColumns.indexOf($scope.hidingList[index]) === -1) {
          $window.$('#_' + dsaComponentsConfig.localStoragePrefix + '_' + gridIdentifierName).jqxGrid('hidecolumn', $scope.hidingList[index]);
        }
      }
      for (var hideIndex in userSettings.gridsSetting[gridSettingId].hidingColumns) {
        if ($scope.hidingList.indexOf(userSettings.gridsSetting[gridSettingId].hidingColumns[hideIndex]) === -1) {
          $window.$('#_' + dsaComponentsConfig.localStoragePrefix + '_' + gridIdentifierName).jqxGrid('showcolumn', userSettings.gridsSetting[gridSettingId].hidingColumns[hideIndex]);
        }
      }
      userSettings.gridsSetting[gridSettingId].hidingColumns = $scope.hidingList;
      userSettings.gridsSetting[gridSettingId].columnsOrders = $scope.showingList;
      for (var oldCount = 0; oldCount < _oldFrozenCount; oldCount++) {
        $window.$('#_' + dsaComponentsConfig.localStoragePrefix + '_' + gridIdentifierName).jqxGrid('unpincolumn', $scope.showingList[oldCount].name);
      }
      userSettings.gridsSetting[gridSettingId].frozenColumns = _.slice($scope.showingList, 0, $scope.frozenColumns);
      gridServiceArgs.saveUserSettings(userSettings);
      $window.location.reload();
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /**
    * Rest the grid to its initial state .
    * Removes the localstorage of the related grid .
    * Removes related entry in the  'userSettings' object.
    *
    */
    $scope.reset = function () {

      if (modelName) {
        gridServiceArgs.removeGridStateStorage(modelName, gridName);
      } else if ($('#' + gridSettingId).length > 0) {
        gridServiceArgs.removeGridStateStorage(gridSettingId);//gridIdentifierName
      } else if ($('#' + gridIdentifierName).length > 0) {
        gridServiceArgs.removeGridStateStorage(gridIdentifierName);//gridIdentifierName
      }

      delete userSettings.gridsSetting[gridSettingId];
      gridServiceArgs.saveUserSettings(userSettings);
      $window.location.reload();
      $uibModalInstance.dismiss('cancel');
    };


    /**
     * update array index.
     * @param moveSide  0,1  0: move up ,1:move down
     */
    function moveArrayIndex(arr, selectIndex, moveSide) {
      var temp;
      if (moveSide === 0) {
        if (selectIndex === 0) {
          return;
        }
        temp = arr[selectIndex];
        arr[selectIndex] = arr[selectIndex - 1];
        arr[selectIndex - 1] = temp;
      } else if (moveSide === 1) {
        if (selectIndex === arr.length - 1) {
          return;
        }

        temp = arr[selectIndex];
        arr[selectIndex] = arr[selectIndex + 1];
        arr[selectIndex + 1] = temp;
      }
    }

  });

/**
 * Created by zml on 4/28/2016.
 */


(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .service('PubSubService', PubSubService);

  PubSubService.$inject = ['$rootScope'];

  /* @ngInject */
  function PubSubService($rootScope) {
    this.publish = publish;
    this.subscribe = subscribe;

    var _DATA_UPDATED_ = '_DATA_UPDATED_';

    ////////////////

    /**
     * Publish one specified event.
     * @param msg The event to publish.
     * @param data The attached data.
     */
    function publish(msg, data) {
      msg = msg || _DATA_UPDATED_;
      data = data || {};
      $rootScope.$emit(msg, data);
    }

    /**
     * Subscribe one specified event.
     * @param msg The event to subscribe.
     * @param func The callback method when event happen.
     * @param scope The scope is used to unbind the subscription.
     */
    function subscribe(msg, func, scope) {
      if (!angular.isFunction(func)) {
        return;
      }
      msg = msg || _DATA_UPDATED_;
      if (scope) {
        var unbind = $rootScope.$on(msg, func);
        scope.$on('$destroy', unbind);
      }
    }

  }

})();


/**
 * Created by zml on 4/22/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admContent', AdmContentComponent);

  AdmContentComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmContentComponent(ADM_PATHS) {
    var directive = {
      bindToController: true,
      controller: AdmContentController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.CONTENT + '/adm-content.component.html',
      restrict: 'E',
      scope: {}
    };
    return directive;

  }

  AdmContentController.$inject = [];

  /* @ngInject */
  function AdmContentController() {
  }

})();


(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admCtrlbarSwitch', AdmCtrlSwitchComponent);

  AdmCtrlSwitchComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmCtrlSwitchComponent(ADM_PATHS) {
    var directive = {
      scope: {},
      bindToController: {},
      controller: AdmCtrlSwitchController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: ADM_PATHS.CTRLBAR + '/adm-ctrlbar-switch.component.html',
      replace: true
    };
    return directive;
  }

  AdmCtrlSwitchController.$inject = ['AdmStatusService'];

  /* @ngInject */
  function AdmCtrlSwitchController(AdmStatusService) {
    var vm = this;
    vm.toggleCtrlBar = toggleCtrlBar;

    ////////////////////////

    function toggleCtrlBar() {
      AdmStatusService.toggleCtrlBar();
    }
  }

})();


/**
 * Created by zml on 4/22/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admCtrlbar', AdmCtrlbarComponent);

  AdmCtrlbarComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmCtrlbarComponent(ADM_PATHS) {
    var directive = {
      bindToController: true,
      controller: AdmCtrlbarController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.CTRLBAR + '/adm-ctrlbar.component.html',
      restrict: 'E',
      scope: {}
    };
    return directive;

  }

  AdmCtrlbarController.$inject = ['AdmStatusService'];

  /* @ngInject */
  function AdmCtrlbarController(AdmStatusService) {
    var vm = this;
    vm.isCtrlBarOpened = isCtrlBarOpened;

    function isCtrlBarOpened() {
      return AdmStatusService.getCtrlBarStatus().isOpened;
    }
  }

})();


/**
 * Created by zml on 4/22/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admFooter', AdmFooterComponent);

  AdmFooterComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmFooterComponent(ADM_PATHS) {
    var directive = {
      bindToController: {
        model: '='
      },
      controller: AdmFooterController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.FOOTER + '/adm-footer.component.html',
      restrict: 'E',
      scope: {}
    };
    return directive;

  }

  AdmFooterController.$inject = [];

  /* @ngInject */
  function AdmFooterController() {
  }

})();


/**
 * Created by haj on 4/27/2016.
 */
(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admHeaderLanguage', AdmHeaderLanguageComponent);

  AdmHeaderLanguageComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmHeaderLanguageComponent(ADM_PATHS) {
    var directive = {
      scope: {},
      bindToController: {
        model: '='
      },
      controller: AdmHeaderLanguageController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: ADM_PATHS.HEADER + '/adm-header-language.component.html',
      replace: true,
      transclude: true
    };
    return directive;
  }

  AdmHeaderLanguageController.$inject = ['AuthenticationService', 'languageService', '$translate', '$locale', 'tmhDynamicLocale', '$scope', '$rootScope'];

  /* @ngInject */
  function AdmHeaderLanguageController(AuthenticationService, languageService, $translate, $locale, tmhDynamicLocale, $scope, $rootScope) {
    var vm = this;

    vm.isLogin = AuthenticationService.IsLogin();
    vm.currentLanguage = languageService.getLanguageSettings().language;
    $translate.use(vm.currentLanguage);

    $scope.$watch(function () {
      return AuthenticationService.IsLogin();
    }, function (data) {
      vm.isLogin = data;
      if (data) {
        vm.userName = AuthenticationService.GetLoginUserName();
        saveLanguage();
      }
    }, true);

    vm.userName = AuthenticationService.GetLoginUserName();

    vm.setLang = function (langKey) {
      // You can change the language during runtime
      $translate.use(langKey);
      vm.currentLanguage = langKey;
      $rootScope.model = { selectedLocale: langKey };
      tmhDynamicLocale.set(langKey);
      $rootScope.$locale = $locale;
      vm.locale = $locale;
      saveLanguage();
    };

    var saveLanguage = function () {
      if (languageService.getLanguageSettings().language !== '' && languageService.getLanguageSettings().language === vm.currentLanguage) {
        $translate.use(languageService.getLanguageSettings().language);
      } else {
        var currentLanguageSettings = languageService.getLanguageSettings();
        currentLanguageSettings.language = vm.currentLanguage;
        languageService.saveLanguageSettings(currentLanguageSettings);
        $translate.use(languageService.getLanguageSettings().language);
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admHeaderMessage', AdmHeaderMessageComponent);

  AdmHeaderMessageComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmHeaderMessageComponent(ADM_PATHS) {
    var directive = {
      bindToController: {},
      controller: AdmHeaderMessageController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: ADM_PATHS.HEADER + '/adm-header-message.component.html',
      replace: true,
      scope: {}
    };
    return directive;
  }

  AdmHeaderMessageController.$inject = [];

  /* @ngInject */
  function AdmHeaderMessageController() {
    // console.info($scope);
  }

})();


(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admHeaderUser', AdmHeaderUserComponent);

  AdmHeaderUserComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmHeaderUserComponent(ADM_PATHS) {
    var directive = {
      scope: {},
      bindToController: {
        model: '='
      },
      controller: AdmHeaderUserController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: ADM_PATHS.HEADER + '/adm-header-user.component.html',
      replace: true
    };
    return directive;
  }

  AdmHeaderUserController.$inject = [];

  /* @ngInject */
  function AdmHeaderUserController() {
  }

})();


/**
 * Created by zml on 4/22/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admHeader', AdmHeaderComponent);

  AdmHeaderComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmHeaderComponent(ADM_PATHS) {
    var directive = {
      scope: true, // TODO: isolate scope is not working here.
      bindToController: {
        model: '='
      },
      controller: AdmHeaderController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.HEADER + '/adm-header.component.html',
      restrict: 'E',
      transclude: true
    };
    return directive;

  }

  AdmHeaderController.$inject = ['AdmStatusService'];

  /* @ngInject */
  function AdmHeaderController(AdmStatusService) {
    var vm = this;

    vm.toggleSideBar = toggleSideBar;
    vm.toggleCtrlBar = toggleCtrlBar;

    /////////////////////

    function toggleSideBar() {
      AdmStatusService.toggleSidebar();
    }

    function toggleCtrlBar() {
      AdmStatusService.toggleCtrlBar();
    }
  }

})();


/**
 * Created by zml on 2016/4/23.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admSidebarSearch', AdmSideBarSearchComponent);

  AdmSideBarSearchComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmSideBarSearchComponent(ADM_PATHS) {
    var directive = {
      scope: {},
      bindToController: {},
      controller: AdmSideBarSearchController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.SIDEBAR + '/adm-sidebar-search.component.html',
      restrict: 'E'
    };
    return directive;
  }

  AdmSideBarSearchController.$inject = [];

  /* @ngInject */
  function AdmSideBarSearchController() {
  }

})();


/**f
 * Created by zml on 2016/4/23.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admSidebarUser', AdmSideBarUserComponent);

  AdmSideBarUserComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmSideBarUserComponent(ADM_PATHS) {
    var directive = {
      scope: {},
      bindToController: {
        model: '='
      },
      controller: AdmSideBarUserController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.SIDEBAR + '/adm-sidebar-user.component.html',
      restrict: 'E'
    };
    return directive;
  }

  AdmSideBarUserController.$inject = [];

  /* @ngInject */
  function AdmSideBarUserController() {
  }
})();


/**
 * Created by zml on 4/22/2016.
 */

(function () {
  'use strict';

  angular
    .module('angular-adminlte')
    .directive('admSidebar', AdmSideBarComponent);

  AdmSideBarComponent.$inject = ['ADM_PATHS'];

  /* @ngInject */
  function AdmSideBarComponent(ADM_PATHS) {
    var directive = {
      scope: true,  // TODO: isolate scope is not working here.
      bindToController: {
        model: '='
      },
      controller: AdmSideBarController,
      controllerAs: 'vm',
      templateUrl: ADM_PATHS.SIDEBAR + '/adm-sidebar.component.html',
      restrict: 'E',
      transclude: true
    };
    return directive;
  }

  AdmSideBarController.$inject = ['AdmStatusService'];

  /* @ngInject */
  function AdmSideBarController(AdmStatusService) {
    var vm = this;

    // vm.toggleItem = toggleItem;
    vm.treeItemClicked = treeItemClicked;
    vm.toggleTreeView = toggleTreeView;
    vm.isSidebarVisible = isSidebarVisible;
    vm.isTreeItemVisible = isTreeItemVisible;

    ////////////////

    function toggleTreeView(treeView) {
      //Keep the state first since deactiveLastActiveItem() will change the value.
      var isActive = !treeView.active;

      deactiveLastActiveItem();
      treeView.active = isActive;

      // var lastOpenedItem = _.find(vm.model.treeItems, {'opened': true});
      // if (lastOpenedItem && lastOpenedItem !== item) {
      //   lastOpenedItem.opened = false;
      // }
      // if (item) {
      //   item.opened = !item.opened;
      // }

      // _.chain(vm.model.treeItems).flatMap(function (item) {
      //   if (item.type === 'treeview') {
      //     return [item.childs, item];
      //   }
      //   return item;
      // }).flattenDeep().filter(function (item) {
      //   return (pItem !== item) && (item.opened || item.active);
      // }).forEach(function (item) {
      //   item.opened = false;
      //   item.active = false;
      // });
      // if (pItem) {
      //   pItem.opened = !pItem.opened;
      //   pItem.active = true;
      // }
    }

    function treeItemClicked(item, child) {
      deactiveLastActiveItem();
      if (item) {
        item.active = true;
      }
      if (child.click) {
        child.click();
      }
      if (child) {
        child.active = true;
      }
    }

    function deactiveLastActiveItem() {
      var lastActiveItem = _.find(vm.model.treeItems, { 'active': true });
      if (lastActiveItem) {
        lastActiveItem.active = false;

        lastActiveItem = _.find(lastActiveItem.childs, { 'active': true });
        if (lastActiveItem) {
          lastActiveItem.active = false;
        }
      }
    }

    function isSidebarVisible() {
      return AdmStatusService.getSideBarStatus().isVisible;
    }

    function isTreeItemVisible(item) {

      // default is showing.
      if (_.isUndefined(item.isVisible)) {
        return true;
      }

      // function
      if (_.isFunction(item.isVisible)) {
        return item.isVisible();
      }

      // boolean.
      return !!item.isVisible;
    }

  }
})();


(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/adm-framework.component.html',
      '<div class="hold-transition skin-customer sidebar-mini" ng-class="[vm.isSidebarCollapsed() ? \'sidebar-collapse\' : \'sidebar-open\', vm.isSidebarVisible() ? \'\' : \'hide-side-bar\']" style="height: 100%"><div class="wrapper"><ng-transclude></ng-transclude></div></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('login/dsalogin.tpl.html',
      '<div style="z-index:10; margin-top:120px;" class="col-md-4 col-md-offset-4"><div class="login-panel panel login-panel-info panel-info"><div class="login-panel-heading panel-heading"><div class="panel-title login-panel-title">{{title}}</div><div style="float: right; font-size: 80%; position: relative; top: -10px"><a href="#"/></div></div><div style="padding-top: 10px" class="panel-body"><form name="loginForm" class="form-horizontal" ng-submit="login()" form-autofill-fix=""><div style="margin-top: 25px" class="input-group" ng-show="!accountIDAvailable"><span class="input-group-addon"><i class="glyphicon glyphicon-user"/></span><input type="text" class="form-control" name="Account" ng-model="loginID.Account" placeholder="{{\'login.placeHolder.Account\' | translate}}" ng-keypress="onKeyPress($event)" required=""/></div><div style="margin-top: 25px" class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-user"/></span><input type="text" class="form-control" name="username" ng-model="loginID.username" placeholder="{{\'login.placeHolder.username\' | translate}}" ng-keypress="onKeyPress($event)" required=""/></div><div style="margin-top: 25px" class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-lock"/></span><input type="password" class="form-control" name="password" ng-model="credentials.password" placeholder="{{ \'login.placeHolder.password\'| translate}}" ng-keypress="onKeyPress($event)" required=""/></div><span us-spinner="{radius:16, width:6, length: 12, color: \'#336AA0\',}" spinner-key="loginSpinner"/><div style="margin-top: 20px" class="form-group"><div class="col-sm-12 controls" align="center"><input type="submit" id="btn-login" class="btn btn-primary" value="Login" ng-click="login()"><a ng-click="forgotPassword()" id="btn-forgotpassword" value="Forgot Password" style="margin-top: 18px; display: block; font-size: 11px; cursor: pointer">{{ \'login.placeHolder.forgotPassword\'| translate}}</a></div></div></div></div><div ng-show="error" class="alert alert-danger">{{error}}</div></form></div></div></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('login/dsaForgotPassword.tpl.html',
      '<div class="modal-content ng-scope"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">x</span><span class="sr-only">Close</span></button><h4 class="modal-title ng-scope">{{title}}</h4></div><div class="modal-body"><form name="forgotPasswordForm" class="form-horizontal" ng-submit="submit()" form-autofill-fix=""><div style="margin-top: 25px" class="input-group" ng-repeat="(key, prop) in loginID track by key"><span class="input-group-addon"><i class="glyphicon glyphicon-user"/></span><input type="text" class="form-control" name="{{key}}" ng-model="loginID[key]" placeholder="{{\'login.placeHolder.\'+key|translate}}" ng-keypress="onKeyPress($event)" required=""></div><div style="margin-top: 25px" class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-envelope"/></span><input type="email" class="form-control" name="email" ng-model="credentials.email" placeholder="{{ \'login.placeHolder.email\'| translate}}" ng-keypress="onKeyPress($event)" required=""></div></form><span us-spinner="{radius:16, width:6, length: 12, color: \'#336AA0\',}" spinner-key="loginSpinner"/></div><!-- ngRepeat: alert in alerts --><div ng-repeat="alert in alerts" class="col-xs-12 col-sm-12 col-md-12"><uib-alert ng-if="true == alert.autoDismiss" type="{{alert.type}}" close="closeAlertByIndex($index)" dismiss-on-timeout="3000" style="margin-bottom: 5px;">{{alert.msg}}</uib-alert><uib-alert ng-if="true != alert.autoDismiss" type="{{alert.type}}" close="closeAlertByIndex($index)" style="margin-bottom: 5px;">{{alert.msg}}</uib-alert></div><div class="modal-footer" style="margin-top: 15px"><button type="button" class="btn btn-primary ng-scope" ng-click="submit()" translate="passwordChange.submit">Submit</button><button type="button" class="btn btn-warning ng-scope" data-dismiss="modal" ng-click="close()" translate="passwordChange.close">Close</button></div></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('widgetSettingsCreator/gridPreference/gridPreference.tpl.html',
     '<div xmlns="http://www.w3.org/1999/html"> <form name="truckMixerCapacityForm"> <div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only"></span></button> <h3 class="modal-title">{{\'settings.gridPreference.setting\' | translate}}&nbsp;/&nbsp;<label translate="{{modelTranslatePath}}"></label></h3> </div> <div class="modal-body"> <div class="row"> <div class="col-xs-12 col-sm-12 col-md-6"><label class="input-label" translate="settings.gridPreference.backgroundColor"></label> <jqx-drop-down-button jqx-on-opening="openColorPicker()" jqx-width="150" jqx-instance="colorPickerButtonInstance" jqx-height="22"> <jqx-color-picker jqx-create="createColorPicker" jqx-on-colorchange="colorChange(event)" jqx-color="\'ffaabb\'" jqx-color-mode="\'hue\'" jqx-width="120" jqx-height="220"></jqx-color-picker> </jqx-drop-down-button> </div> <div class="col-xs-12 col-sm-12 col-md-6"><label class="input-label" translate="settings.gridPreference.pinnedColumn"></label> <div style="padding: 2px;"><input type="text" ng-model="frozenColumns" input-number-validate="" style="width: 150px;"></div> </div> </div> <div class="row"> <div class="col-xs-12 col-sm-12 col-md-12"><label class="input-label" translate="settings.gridPreference.showingColumns"></label></div> <div class="col-xs-10 col-sm-10 col-md-9"> <jqx-list-box id="columnsListBox" ng-model="selectedValue" jqx-settings="columnsListBoxSettings" jqx-on-check-change="onCheckChange(event)"></jqx-list-box> </div> <div class="col-xs-2 col-sm-2 col-md-3 grid-setting-control-btn"> <div> <div class="row"><button type="button" ng-click="moveUp()" class="btn btn-primary" style="margin-bottom: 5px;"><span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button> </div> <div class="row"><button type="button" ng-click="moveDown()" class="btn btn-primary" style="margin-bottom: 5px;"><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button> </div> <div class="row grid-settings-restore-btn"> <button type="button" class="btn btn-primary" ng-click="reset()" translate="settings.gridPreference.reset"></button> </div> </div> </div> </div> </div> <div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="save()" translate="button.save"></button> <button type="button" class="btn btn-primary" ng-click="cancel()" translate="button.cancel"></button></div> </form> </div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/content/adm-content.component.html',
      '<div class="content-wrapper" style="height:100%" ui-view="content"><div>To be continue...</div></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/header/adm-header-language.component.html',
      '<li class="dropdown" ng-show="!vm.isLogin"><a class="dropdown-toggle" data-toggle="dropdown"><i class="glyphicon glyphicon-globe"></i> <span translate="nav.language.{{vm.currentLanguage}}"></span><span class="caret"></span></a><ul class="dropdown-menu" role="menu"><li ng-repeat="item in vm.model.languages"><a ng-click="vm.setLang(item)" translate="nav.language.{{item}}"></a></li></ul></li>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/header/adm-header-message.component.html',
      '<li class="dropdown messages-menu"><a class="dropdown-toggle" data-toggle="dropdown"><i class="fa fa-envelope-o"></i> <span class="label label-success">4</span></a><ul class="dropdown-menu"><li class="header">You have 4 messages</li><li><ul class="menu"><li><a href="#"><div class="pull-left"><img src="assets/img/user2-160x160.jpg" class="img-circle" alt="User Image"></div><h4>Support Team <small><i class="fa fa-clock-o"></i> 5 mins</small></h4><p>Why not buy a new awesome theme?</p></a></li><li><a href="#"><div class="pull-left"><img src="assets/img/user3-128x128.jpg" class="img-circle" alt="User Image"></div><h4>AdminLTE Design Team <small><i class="fa fa-clock-o"></i> 2 hours</small></h4><p>Why not buy a new awesome theme?</p></a></li><li><a href="#"><div class="pull-left"><img src="assets/img/user4-128x128.jpg" class="img-circle" alt="User Image"></div><h4>Developers <small><i class="fa fa-clock-o"></i> Today</small></h4><p>Why not buy a new awesome theme?</p></a></li><li><a href="#"><div class="pull-left"><img src="assets/img/user3-128x128.jpg" class="img-circle" alt="User Image"></div><h4>Sales Department <small><i class="fa fa-clock-o"></i> Yesterday</small></h4><p>Why not buy a new awesome theme?</p></a></li><li><a href="#"><div class="pull-left"><img src="assets/img/user4-128x128.jpg" class="img-circle" alt="User Image"></div><h4>Reviewers <small><i class="fa fa-clock-o"></i> 2 days</small></h4><p>Why not buy a new awesome theme?</p></a></li></ul></li><li class="footer"><a href="#">See All Messages</a></li></ul></li>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/header/adm-header-user.component.html',
      '<li class="dropdown user user-menu" ng-show="vm.model.isVisible"><a class="dropdown-toggle" data-toggle="dropdown"><img ng-src="{{vm.model.imgUrl}}" class="user-image" alt="User Image"> <span class="hidden-xs">{{vm.model.name}}</span></a><ul class="dropdown-menu"><li class="user-header"><img ng-src="{{vm.model.imgUrl}}" class="img-circle" alt="User Image"><p>{{vm.model.name}} <small>{{vm.model.description}}</small></p></li><li class="user-footer"><div class="pull-left"><a class="btn btn-default btn-flat" ng-click="vm.model.passwordFn()">{{::"nav.user.changePassword"|translate}}</a></div><div class="pull-right"><a class="btn btn-default btn-flat" ng-click="vm.model.logoutFn()">{{::"nav.user.logout"|translate}}</a></div></li></ul></li>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/header/adm-header.component.html',
      '<header class="main-header" ui-view="header"><a ui-sref="{{vm.model.href}}" class="logo"><span class="logo-mini" ng-bind-html="vm.model.miniLogo"></span><span class="logo-lg" ng-bind-html="vm.model.logo"></span></a><nav class="navbar navbar-static-top"><a ng-click="vm.toggleSideBar()" class="sidebar-toggle" data-toggle="offcanvas" role="button"><span class="sr-only">Toggle navigation</span></a><div class="navbar-custom-menu"><ul class="nav navbar-nav" ng-transclude=""></ul></div></nav></header>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/ctrlbar/adm-ctrlbar-switch.component.html',
      '<li><a ng-click="vm.toggleCtrlBar()" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a></li>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/ctrlbar/adm-ctrlbar.component.html',
      '<aside class="control-sidebar control-sidebar-dark" ng-class="vm.isCtrlBarOpened() ? \'control-sidebar-open\' : \'\'"><ul class="nav nav-tabs nav-justified control-sidebar-tabs"><li class="active"><a href="#control-sidebar-home-tab" data-toggle="tab" aria-expanded="true"><i class="fa fa-home"></i></a></li><li><a href="#control-sidebar-settings-tab" data-toggle="tab"><i class="fa fa-gears"></i></a></li></ul><div class="tab-content"><div class="tab-pane" id="control-sidebar-home-tab"><h3 class="control-sidebar-heading">Recent Activity</h3><ul class="control-sidebar-menu"><li><a href="javascript:void(0)"><i class="menu-icon fa fa-birthday-cake bg-red"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Langdon\'s Birthday</h4><p>Will be 23 on April 24th</p></div></a></li><li><a href="javascript:void(0)"><i class="menu-icon fa fa-user bg-yellow"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Frodo Updated His Profile</h4><p>New phone +1(800)555-1234</p></div></a></li><li><a href="javascript:void(0)"><i class="menu-icon fa fa-envelope-o bg-light-blue"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Nora Joined Mailing List</h4><p>nora@example.com</p></div></a></li><li><a href="javascript:void(0)"><i class="menu-icon fa fa-file-code-o bg-green"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Cron Job 254 Executed</h4><p>Execution time 5 seconds</p></div></a></li></ul><h3 class="control-sidebar-heading">Tasks Progress</h3><ul class="control-sidebar-menu"><li><a href="javascript:void(0)"><h4 class="control-sidebar-subheading">Custom Template Design <span class="label label-danger pull-right">70%</span></h4><div class="progress progress-xxs"><div class="progress-bar progress-bar-danger" style="width: 70%"></div></div></a></li><li><a href="javascript:void(0)"><h4 class="control-sidebar-subheading">Update Resume <span class="label label-success pull-right">95%</span></h4><div class="progress progress-xxs"><div class="progress-bar progress-bar-success" style="width: 95%"></div></div></a></li><li><a href="javascript:void(0)"><h4 class="control-sidebar-subheading">Laravel Integration <span class="label label-warning pull-right">50%</span></h4><div class="progress progress-xxs"><div class="progress-bar progress-bar-warning" style="width: 50%"></div></div></a></li><li><a href="javascript:void(0)"><h4 class="control-sidebar-subheading">Back End Framework <span class="label label-primary pull-right">68%</span></h4><div class="progress progress-xxs"><div class="progress-bar progress-bar-primary" style="width: 68%"></div></div></a></li></ul></div><div class="tab-pane" id="control-sidebar-stats-tab">Stats Tab Content</div><div class="tab-pane" id="control-sidebar-settings-tab"><form method="post"><h3 class="control-sidebar-heading">General Settings</h3><div class="form-group"><label class="control-sidebar-subheading">Report panel usage <input type="checkbox" class="pull-right" checked=""></label><p>Some information about this general settings option</p></div><div class="form-group"><label class="control-sidebar-subheading">Allow mail redirect <input type="checkbox" class="pull-right" checked=""></label><p>Other sets of options are available</p></div><div class="form-group"><label class="control-sidebar-subheading">Expose author name in posts <input type="checkbox" class="pull-right" checked=""></label><p>Allow the user to show his name in blog posts</p></div><h3 class="control-sidebar-heading">Chat Settings</h3><div class="form-group"><label class="control-sidebar-subheading">Show me as online <input type="checkbox" class="pull-right" checked=""></label></div><div class="form-group"><label class="control-sidebar-subheading">Turn off notifications <input type="checkbox" class="pull-right"></label></div><div class="form-group"><label class="control-sidebar-subheading">Delete chat history <a href="javascript:void(0)" class="text-red pull-right"><i class="fa fa-trash-o"></i></a></label></div></form></div></div></aside><div class="control-sidebar-bg" style="position: fixed; height: auto;"></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/footer/adm-footer.component.html',
      '<footer class="main-footer" ui-view="footer"><div class="pull-right hidden-xs"><b>Version</b> {{vm.model.version}}</div><strong>{{vm.model.copyRight}}</strong></footer>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/sidebar/adm-sidebar-search.component.html',
      '<form action="#" method="get" class="sidebar-form"><div class="input-group"><input type="text" name="q" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="submit" name="search" id="search-btn" class="btn btn-flat"><i class="fa fa-search"></i></button></span></div></form>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/sidebar/adm-sidebar-user.component.html',
      '<div class="user-panel"><div class="pull-left image"><img ng-src="{{vm.model.imgUrl}}" class="img-circle" alt="User Image"></div><div class="pull-left info"><p>{{vm.model.name}}</p><a><i ng-class="vm.model.statusClass"></i> {{vm.model.status}}</a></div></div>');
  }]);
})();

(function (module) {
  try {
    module = angular.module('dsaComponents');
  } catch (e) {
    module = angular.module('dsaComponents', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('angular-adminlte/components/sidebar/adm-sidebar.component.html', '<aside class="main-sidebar" ui-view="sidebar" ng-if="vm.isSidebarVisible()"><section class="sidebar"><ng-transclude></ng-transclude><ul class="sidebar-menu"><li ng-repeat="item in vm.model.treeItems" ng-class="[item.type, item.active ? \'active\' : \'\']" ng-disabled="item.isDisabled" ng-if="vm.isTreeItemVisible(item)">{{item.type === \'header\' ? (item.text | translate) : \'\'}} <a ng-click="vm.toggleTreeView(item)" ng-if="item.childs && item.type!==\'header\'"><i class="{{item.leftClass}}"><span class="counter-dsa" ng-if="item.text == \'sidebar.betotrack.fms\'" ng-show="item.failures > 0 || item.failures === \'99+\'">{{item.failures}}</span></i> <span class="translate" ng-class="{counterDsaTranslation: item.failures > 0 || item.failures === \'99+\'}" translate="{{item.text}}"/>					<span class="pull-right-container"><small ng-class="(item.active && item.rightActiveClass) ? item.rightActiveClass : item.rightClass">{{item.rightText}}</small></span></a> <a ng-click="vm.toggleTreeView(item)" ng-if="!item.childs && item.type!==\'header\'" ng-attr-ui-sref="{{item.href}}" ng-class="[item.isDisabled ? \'disabled\':\'\']"><i class="{{item.leftClass}}"><span class="counter-dsa" ng-if="item.text == \'sidebar.betotrack.fms\'" ng-show="item.failures > 0 || item.failures === \'99+\'">{{item.failures}}</span></i> <span class="translate" ng-class="{counterDsaTranslation: item.failures > 0 || item.failures === \'99+\'}" translate="{{item.text}}"></span> <span class="pull-right-container"><small ng-class="(item.active && item.rightActiveClass) ? item.rightActiveClass : item.rightClass">{{item.rightText}}</small></span></a><ul ng-if="item.childs" class="treeview-menu" ng-class="item.active ? \'menu-open\' : \'\'"><li ng-repeat="child in item.childs" ng-class="[child.type, child.active ? \'active\' : \'\']" ng-disabled="child.isDisabled" ng-if="vm.isTreeItemVisible(item)"><a ng-click="vm.treeItemClicked(item,child)" ui-sref="{{child.href}}" ng-class="[child.isDisabled ? \'disabled\':\'\']"><i class="{{child.leftClass}}"/><span translate="{{child.text}}"/><span class="pull-right-container"><small ng-class="(child.active && child.rightActiveClass) ? child.rightActiveClass : child.rightClass">{{child.rightText}}</small></span></a></li></ul></li></ul></section></aside>');
  }]);
})();



// WEBPACK FOOTER //
// ./src/vendor/dsacomponents/dsacomponents.js